import { isEmpty, isString, map } from 'lodash'
import { User } from '../../user'
import { DLLedger } from './ledger'

interface CreateDLCompanyInput {
  name: string
  rcs: string
}

interface UpdateDLCompanyInput {
  name: string
  rcs: string
}

export class DLCompany {
  id: string
  
  name: string
  rcs: string
  ledgers: DLLedger[]

  createdAt: number
  createdBy: User
  updatedAt: number
  updatedBy: User

  constructor(data: any = {}) {
    Object.assign(this, data);

    if(this.ledgers) {
      this.ledgers = map(data.ledgers, l => new DLLedger(l));
    }

    if(this.createdBy) {
      this.createdBy = new User(this.createdBy);
    }

    if(this.updatedBy) {
      this.updatedBy = new User(this.updatedBy);
    }
  }

  get valid():boolean {
    // name
    if(!isString(this.name)) {
      return false;
    }

    let trimmedName = this.name.trim();

    if(trimmedName.length > 50) {
      return false;
    }

    return true;
  }

  get fullname() {
    let fullname = this.name;

    if (!isEmpty(this.rcs)) {
      fullname += ` / ${this.rcs}`
    }

    return fullname;
  }

  toCreateDLCompanyInput(): CreateDLCompanyInput {
    return {
      name: this.name,
      rcs: this.rcs,
    };
  }

  toUpdateDLCompanyInput(): UpdateDLCompanyInput {
    return {
      name: this.name,
      rcs: this.rcs,
    };
  }
}
